import { Link } from 'react-router-dom';
import { ShoppingBag, Truck, Star, ArrowRight } from 'lucide-react';

const Home = () => {
  return (
    <div className="bg-off_white" data-testid="home-page">
      {/* Hero Section */}
      <section className="relative overflow-hidden bg-gradient-to-br from-white via-green-50 to-green-200 border-b-4 border-black">
        {/* Fruit Explosion Animation */}
        <div className="absolute top-10 left-10 w-16 h-16 animate-ping">
          <div className="absolute inset-0 bg-brand_yellow rounded-full"></div>
          <div className="absolute top-0 left-0 w-4 h-4 bg-brand_red rounded-full animate-bounce" style={{ animationDelay: '0s' }}></div>
          <div className="absolute top-0 right-0 w-3 h-3 bg-brand_blue rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          <div className="absolute bottom-0 left-0 w-3 h-3 bg-brand_green rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
          <div className="absolute bottom-0 right-0 w-4 h-4 bg-orange-500 rounded-full animate-bounce" style={{ animationDelay: '0.6s' }}></div>
        </div>
        <div className="absolute top-32 right-20 w-12 h-12 animate-ping" style={{ animationDelay: '1s' }}>
          <div className="absolute inset-0 bg-brand_red rounded-full"></div>
          <div className="absolute -top-2 left-1/2 w-3 h-3 bg-brand_yellow rounded-full animate-bounce"></div>
          <div className="absolute top-1/2 -right-2 w-2 h-2 bg-brand_green rounded-full animate-bounce"></div>
          <div className="absolute -bottom-2 left-1/2 w-3 h-3 bg-brand_blue rounded-full animate-bounce"></div>
          <div className="absolute top-1/2 -left-2 w-2 h-2 bg-orange-500 rounded-full animate-bounce"></div>
        </div>
        
        {/* BIG Decorative Stars */}
        {/* Row 1 - Top */}
        <div className="absolute top-6 left-12 w-20 h-20">
          <div className="w-full h-full bg-brand_red/80 animate-pulse" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '3s' }} />
        </div>
        <div className="absolute top-10 left-1/4 w-16 h-16">
          <div className="w-full h-full bg-brand_yellow/70 rotate-12" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)' }} />
        </div>
        <div className="absolute top-4 right-1/4 w-24 h-24">
          <div className="w-full h-full bg-brand_blue/60 animate-spin" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '12s' }} />
        </div>
        <div className="absolute top-8 right-12 w-18 h-18" style={{ width: '4.5rem', height: '4.5rem' }}>
          <div className="w-full h-full bg-brand_green/70 animate-pulse" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '2.5s' }} />
        </div>

        {/* Row 2 - Upper Middle */}
        <div className="absolute top-1/4 left-8 w-14 h-14">
          <div className="w-full h-full bg-orange-400/80 rotate-45" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)' }} />
        </div>
        <div className="absolute top-1/4 left-[15%] w-20 h-20">
          <div className="w-full h-full bg-brand_red/60 animate-spin" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '9s' }} />
        </div>
        <div className="absolute top-1/3 right-[12%] w-16 h-16">
          <div className="w-full h-full bg-brand_yellow/90 rotate-12 animate-pulse" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '2s' }} />
        </div>
        <div className="absolute top-1/3 right-8 w-20 h-20">
          <div className="w-full h-full bg-pink-400/70" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)' }} />
        </div>

        {/* Row 3 - Center */}
        <div className="absolute top-1/2 left-4 w-24 h-24">
          <div className="w-full h-full bg-brand_blue/50 animate-pulse" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '4s' }} />
        </div>
        <div className="absolute top-[45%] left-[18%] w-14 h-14">
          <div className="w-full h-full bg-brand_green/80 rotate-45 animate-spin" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '11s' }} />
        </div>
        <div className="absolute top-1/2 right-4 w-20 h-20">
          <div className="w-full h-full bg-brand_red/70 animate-spin" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)', animationDuration: '8s' }} />
        </div>
        <div className="absolute top-[55%] right-[15%] w-16 h-16">
          <div className="w-full h-full bg-orange-300/80 rotate-12" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)' }} />
        </div>

        {/* Row 4 - Lower Middle */}
        <div className="absolute bottom-1/4 left-12 w-18" style={{ width: '4.5rem', height: '4.5rem' }}>
          <div className="w-full h-full bg-brand_yellow/80 animate-pulse" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '3.5s' }} />
        </div>
        <div className="absolute bottom-1/3 left-[20%] w-20 h-20">
          <div className="w-full h-full bg-pink-500/60 rotate-45" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)' }} />
        </div>
        <div className="absolute bottom-1/4 right-[18%] w-14 h-14">
          <div className="w-full h-full bg-brand_blue/70 animate-spin" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '7s' }} />
        </div>
        <div className="absolute bottom-1/3 right-10 w-24 h-24">
          <div className="w-full h-full bg-brand_green/60 animate-pulse" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '2s' }} />
        </div>

        {/* Row 5 - Bottom */}
        <div className="absolute bottom-8 left-20 w-20 h-20">
          <div className="w-full h-full bg-brand_red/70 rotate-12" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)' }} />
        </div>
        <div className="absolute bottom-6 left-[30%] w-16 h-16">
          <div className="w-full h-full bg-orange-500/70 animate-spin" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '10s' }} />
        </div>
        <div className="absolute bottom-10 right-[30%] w-20 h-20">
          <div className="w-full h-full bg-brand_yellow/70 rotate-45 animate-pulse" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '3s' }} />
        </div>
        <div className="absolute bottom-4 right-16 w-24 h-24">
          <div className="w-full h-full bg-brand_blue/50 rotate-12" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)' }} />
        </div>

        {/* Extra scattered big stars */}
        <div className="absolute top-[15%] left-[40%] w-14 h-14">
          <div className="w-full h-full bg-brand_green/50 animate-spin" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '15s' }} />
        </div>
        <div className="absolute top-[70%] left-[8%] w-16 h-16">
          <div className="w-full h-full bg-orange-400/60 rotate-45 animate-pulse" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)', animationDuration: '4s' }} />
        </div>
        <div className="absolute top-[65%] right-[8%] w-14 h-14">
          <div className="w-full h-full bg-pink-400/70 animate-spin" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '13s' }} />
        </div>
        <div className="absolute top-[85%] left-[45%] w-20 h-20">
          <div className="w-full h-full bg-brand_red/50 rotate-12" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)' }} />
        </div>

        {/* Juice Splashes */}
        <svg className="absolute top-[10%] left-[5%] w-40 h-40 opacity-40" viewBox="0 0 200 200">
          <path d="M100,20 Q130,10 140,40 Q160,30 150,60 Q180,55 160,80 Q190,90 160,110 Q175,130 145,130 Q155,160 125,150 Q120,180 95,160 Q80,180 70,150 Q40,165 50,135 Q20,135 40,110 Q10,100 35,80 Q15,65 45,60 Q30,35 60,45 Q55,15 85,25 Z" fill="#FFD700" />
        </svg>
        <svg className="absolute top-[5%] right-[8%] w-36 h-36 opacity-35 rotate-45" viewBox="0 0 200 200">
          <path d="M100,20 Q130,10 140,40 Q160,30 150,60 Q180,55 160,80 Q190,90 160,110 Q175,130 145,130 Q155,160 125,150 Q120,180 95,160 Q80,180 70,150 Q40,165 50,135 Q20,135 40,110 Q10,100 35,80 Q15,65 45,60 Q30,35 60,45 Q55,15 85,25 Z" fill="#FF4444" />
        </svg>
        <svg className="absolute top-[35%] left-[2%] w-32 h-32 opacity-30 -rotate-12" viewBox="0 0 200 200">
          <path d="M100,20 Q130,10 140,40 Q160,30 150,60 Q180,55 160,80 Q190,90 160,110 Q175,130 145,130 Q155,160 125,150 Q120,180 95,160 Q80,180 70,150 Q40,165 50,135 Q20,135 40,110 Q10,100 35,80 Q15,65 45,60 Q30,35 60,45 Q55,15 85,25 Z" fill="#FF8C00" />
        </svg>
        <svg className="absolute top-[40%] right-[3%] w-44 h-44 opacity-30 rotate-90" viewBox="0 0 200 200">
          <path d="M100,20 Q130,10 140,40 Q160,30 150,60 Q180,55 160,80 Q190,90 160,110 Q175,130 145,130 Q155,160 125,150 Q120,180 95,160 Q80,180 70,150 Q40,165 50,135 Q20,135 40,110 Q10,100 35,80 Q15,65 45,60 Q30,35 60,45 Q55,15 85,25 Z" fill="#FFD700" />
        </svg>
        <svg className="absolute bottom-[15%] left-[10%] w-36 h-36 opacity-35 rotate-180" viewBox="0 0 200 200">
          <path d="M100,20 Q130,10 140,40 Q160,30 150,60 Q180,55 160,80 Q190,90 160,110 Q175,130 145,130 Q155,160 125,150 Q120,180 95,160 Q80,180 70,150 Q40,165 50,135 Q20,135 40,110 Q10,100 35,80 Q15,65 45,60 Q30,35 60,45 Q55,15 85,25 Z" fill="#E8353E" />
        </svg>
        <svg className="absolute bottom-[10%] right-[12%] w-40 h-40 opacity-30 -rotate-45" viewBox="0 0 200 200">
          <path d="M100,20 Q130,10 140,40 Q160,30 150,60 Q180,55 160,80 Q190,90 160,110 Q175,130 145,130 Q155,160 125,150 Q120,180 95,160 Q80,180 70,150 Q40,165 50,135 Q20,135 40,110 Q10,100 35,80 Q15,65 45,60 Q30,35 60,45 Q55,15 85,25 Z" fill="#FF6B35" />
        </svg>
        {/* Splash droplets */}
        <svg className="absolute top-[20%] left-[15%] w-10 h-10 opacity-50" viewBox="0 0 50 50">
          <circle cx="25" cy="25" r="20" fill="#FFD700" />
        </svg>
        <svg className="absolute top-[18%] right-[20%] w-8 h-8 opacity-45" viewBox="0 0 50 50">
          <circle cx="25" cy="25" r="20" fill="#FF4444" />
        </svg>
        <svg className="absolute top-[50%] left-[12%] w-12 h-12 opacity-40" viewBox="0 0 50 50">
          <circle cx="25" cy="25" r="20" fill="#FF8C00" />
        </svg>
        <svg className="absolute top-[60%] right-[5%] w-8 h-8 opacity-50" viewBox="0 0 50 50">
          <circle cx="25" cy="25" r="20" fill="#FFD700" />
        </svg>
        <svg className="absolute bottom-[25%] left-[3%] w-6 h-6 opacity-45" viewBox="0 0 50 50">
          <circle cx="25" cy="25" r="20" fill="#E8353E" />
        </svg>
        <svg className="absolute bottom-[20%] right-[18%] w-10 h-10 opacity-40" viewBox="0 0 50 50">
          <circle cx="25" cy="25" r="20" fill="#FF6B35" />
        </svg>
        <svg className="absolute top-[75%] left-[25%] w-7 h-7 opacity-35" viewBox="0 0 50 50">
          <circle cx="25" cy="25" r="20" fill="#FFD700" />
        </svg>
        <svg className="absolute top-[30%] right-[25%] w-9 h-9 opacity-40" viewBox="0 0 50 50">
          <circle cx="25" cy="25" r="20" fill="#FF4444" />
        </svg>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative z-10">
          <div className="text-center">
            <div className="mb-8">
              <img
                src="https://customer-assets.emergentagent.com/job_uncle-dave-lemonade/artifacts/kwt5a30n_UNCLE_20250926_111530_0000.png"
                alt="Uncle Dave's All Natural Lemonade"
                className="mx-auto w-full max-w-4xl"
              />
            </div>
            <h1 className="font-chewy text-5xl sm:text-7xl lg:text-8xl mb-4 text-white" style={{ WebkitTextStroke: '3px black', textShadow: '4px 4px 0px rgba(0,0,0,1), -1px -1px 0px rgba(0,0,0,1), 1px -1px 0px rgba(0,0,0,1), -1px 1px 0px rgba(0,0,0,1)' }}>
              THE BEST LEMONADE<br />EVER MADE
            </h1>
            <p className="font-nunito text-2xl sm:text-3xl text-black font-bold mb-4 max-w-3xl mx-auto">
              Empowering Families Through Entrepreneurship
            </p>
            <div className="font-nunito text-xl sm:text-2xl font-extrabold mb-8 max-w-2xl mx-auto">
              <span className="text-brand_green drop-shadow-[2px_2px_0px_rgba(0,0,0,0.3)]">ALL NATURAL</span>
              <span className="text-black"> • </span>
              <span className="text-brand_blue drop-shadow-[2px_2px_0px_rgba(0,0,0,0.3)]">BLUE AGAVE NECTAR</span>
              <span className="text-black"> • </span>
              <span className="text-brand_red drop-shadow-[2px_2px_0px_rgba(0,0,0,0.3)]">FRESH FRUIT</span>
              <br />
              <span className="text-brand_red drop-shadow-[2px_2px_0px_rgba(0,0,0,0.3)]">MADE WITH A WHOLE LOT OF LOVE ❤️</span>
              <br />
              <span className="text-brand_blue mt-2 inline-block">We Ship Nationwide | Local Pickup Available</span>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link
                to="/products"
                className="inline-block bg-brand_blue text-white font-chewy text-2xl px-12 py-4 rounded-full border-4 border-black shadow-hard-lg hover:shadow-hard-hover hover:-translate-y-1 transition-all"
                data-testid="hero-shop-button"
              >
                SHOP NOW <ArrowRight className="inline-block ml-2" strokeWidth={3} />
              </Link>
              <Link
                to="/popup-program"
                className="inline-block bg-brand_yellow text-black font-chewy text-2xl px-12 py-4 rounded-full border-4 border-black shadow-hard-lg hover:shadow-hard-hover hover:-translate-y-1 transition-all"
              >
                START A POP-UP STAND
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Characters Section */}
      <section className="py-16 bg-black border-b-4 border-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-chewy text-4xl sm:text-6xl text-center mb-12">
            <span className="text-brand_blue drop-shadow-[2px_2px_0px_rgba(255,255,255,1)]">MEET OUR</span>{' '}
            <span className="text-brand_red drop-shadow-[2px_2px_0px_rgba(255,255,255,1)]">FLAVOR CREW!</span>
          </h2>
          <div className="max-w-4xl mx-auto">
            <img
              src="https://customer-assets.emergentagent.com/job_uncle-dave-lemonade/artifacts/kwt5a30n_UNCLE_20250926_111530_0000.png"
              alt="Uncle Dave's Flavor Crew"
              className="w-full h-auto"
            />
          </div>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="py-16 bg-brand_blue border-b-4 border-black relative overflow-hidden">
        {/* Decorative Stars */}
        <div className="absolute top-12 left-12 w-8 h-8 opacity-50">
          <div className="w-full h-full bg-brand_yellow animate-pulse" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)' }} />
        </div>
        <div className="absolute top-1/4 right-16 w-6 h-6 opacity-60">
          <div className="w-full h-full bg-white rotate-12" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)' }} />
        </div>
        <div className="absolute bottom-20 left-1/4 w-7 h-7 opacity-40">
          <div className="w-full h-full bg-brand_red animate-spin" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '12s' }} />
        </div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <h2 className="font-chewy text-4xl sm:text-6xl text-center text-white mb-8 drop-shadow-[2px_2px_0px_rgba(0,0,0,1)]">
            OUR STORY
          </h2>
          <div className="bg-white border-4 border-black rounded-2xl p-8 shadow-hard-lg">
            <p className="font-nunito text-lg leading-relaxed mb-6">
              Once upon a time in the vibrant streets of New York City, there lived a man with many nieces and nephews named <span className="font-bold text-brand_blue">Uncle Dave</span>. Growing up, Uncle Dave had a humble lemonade stand that taught him the value of hard work and financial literacy.
            </p>
            <p className="font-nunito text-lg leading-relaxed mb-6">
              Inspired by his experiences, Uncle Dave created a brand to <span className="font-bold text-brand_red">empower single and non-working parent households</span>. Uncle Dave's All Natural Juice was born with a mission to bring families together and teach financial independence through delicious all-natural juice.
            </p>
            <p className="font-nunito text-lg leading-relaxed mb-6">
              Through our <span className="font-bold text-brand_green">Pop-Up Stand Program</span>, families can rent stands and receive juice supplies, earning a percentage of sales while learning valuable entrepreneurship skills together.
            </p>
            <div className="text-center mt-8">
              <Link
                to="/about"
                className="inline-block bg-brand_yellow text-black font-chewy text-xl px-8 py-3 rounded-full border-4 border-black shadow-hard hover:shadow-hard-hover hover:-translate-y-1 transition-all"
              >
                READ FULL STORY
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Product Showcase Section */}
      <section className="py-16 bg-gradient-to-br from-purple-100 via-pink-100 to-orange-100 border-b-4 border-black relative overflow-hidden">
        {/* More Stars */}
        <div className="absolute top-10 left-10 w-10 h-10">
          <div className="w-full h-full bg-purple-400/70 animate-pulse" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)' }} />
        </div>
        <div className="absolute top-20 right-16 w-8 h-8">
          <div className="w-full h-full bg-pink-400/60 rotate-12" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)' }} />
        </div>
        <div className="absolute bottom-16 left-20 w-9 h-9">
          <div className="w-full h-full bg-orange-400/70 animate-spin" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '9s' }} />
        </div>
        <div className="absolute bottom-32 right-24 w-7 h-7">
          <div className="w-full h-full bg-purple-300/80 rotate-45 animate-pulse" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)', animationDuration: '2s' }} />
        </div>
        <div className="absolute top-1/2 left-1/4 w-6 h-6">
          <div className="w-full h-full bg-pink-500/60 animate-spin" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '12s' }} />
        </div>
        <div className="absolute top-1/3 right-1/3 w-8 h-8">
          <div className="w-full h-full bg-orange-300/70 rotate-12" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)' }} />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <h2 className="font-chewy text-4xl sm:text-6xl text-center mb-12">
            <span className="text-brand_blue">FRESH & NATURAL</span>{' '}
            <span className="text-brand_red">LEMONADES!</span>
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              {
                name: 'OG Lemonade',
                flavor: 'Classic Lemon',
                image: 'https://customer-assets.emergentagent.com/job_e3a7a4f2-0e2f-4141-b731-7e840997bc02/artifacts/wcb51iuk_1_20251221_154647_0000.png',
                price: 4.00
              },
              {
                name: 'Mango Pineapple',
                flavor: 'Tropical Blend',
                image: 'https://customer-assets.emergentagent.com/job_e3a7a4f2-0e2f-4141-b731-7e840997bc02/artifacts/evmxxuef_Untitled%20design_20251220_121222_0000.png',
                price: 4.00
              },
              {
                name: 'Sour Sop',
                flavor: 'Exotic & Refreshing',
                image: 'https://customer-assets.emergentagent.com/job_e3a7a4f2-0e2f-4141-b731-7e840997bc02/artifacts/t2p2wfbk_%F0%9F%A4%8D_20251219_165720_0000.png',
                price: 4.00
              },
              {
                name: 'Strawberry Love',
                flavor: 'Sweet & Fruity',
                image: 'https://customer-assets.emergentagent.com/job_e3a7a4f2-0e2f-4141-b731-7e840997bc02/artifacts/r7xxsdku_1_20251217_225806_0000.png',
                price: 4.00
              }
            ].map((flavor, idx) => (
              <div
                key={idx}
                className="bg-off_white border-4 border-black rounded-2xl p-6 shadow-hard hover:shadow-hard-lg hover:-translate-y-2 transition-all"
              >
                <img
                  src={flavor.image}
                  alt={flavor.name}
                  className="w-full h-48 object-contain mb-4"
                />
                <h3 className="font-chewy text-2xl text-brand_blue text-center mb-2">
                  {flavor.name}
                </h3>
                <p className="font-nunito text-center text-gray-700 font-semibold mb-3">
                  {flavor.flavor}
                </p>
                <p className="font-chewy text-2xl text-brand_red text-center mb-4">
                  ${flavor.price}
                </p>
                <Link
                  to="/products"
                  className="block w-full bg-brand_blue text-white text-center font-nunito font-bold px-4 py-2 rounded-full border-2 border-black shadow-hard hover:shadow-hard-hover hover:-translate-y-0.5 transition-all"
                >
                  Shop Now
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-gradient-to-br from-cyan-100 via-teal-100 to-green-100 relative overflow-hidden">
        {/* More Stars */}
        <div className="absolute top-12 right-12 w-10 h-10">
          <div className="w-full h-full bg-cyan-400/70 animate-pulse" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '2.5s' }} />
        </div>
        <div className="absolute bottom-20 left-16 w-8 h-8">
          <div className="w-full h-full bg-teal-400/60 rotate-12" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)' }} />
        </div>
        <div className="absolute top-1/4 left-24 w-9 h-9">
          <div className="w-full h-full bg-green-400/70 animate-spin" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '11s' }} />
        </div>
        <div className="absolute top-1/3 right-20 w-7 h-7">
          <div className="w-full h-full bg-cyan-300/80 rotate-45 animate-pulse" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)', animationDuration: '3s' }} />
        </div>
        <div className="absolute bottom-1/4 right-1/4 w-6 h-6">
          <div className="w-full h-full bg-teal-500/60 animate-spin" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '13s' }} />
        </div>
        <div className="absolute top-1/2 left-1/3 w-8 h-8">
          <div className="w-full h-full bg-green-300/70 rotate-12" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)' }} />
        </div>
        <div className="absolute bottom-32 left-1/4 w-7 h-7">
          <div className="w-full h-full bg-cyan-500/80 animate-pulse" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '2s' }} />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                icon: ShoppingBag,
                title: 'FRESH INGREDIENTS',
                desc: 'Made with real fruit and blue agave nectar'
              },
              {
                icon: Truck,
                title: 'FAST DELIVERY',
                desc: 'Get your lemonade delivered or pick it up locally'
              },
              {
                icon: Star,
                title: '100% NATURAL',
                desc: 'No artificial flavors, just pure goodness'
              }
            ].map((feature, idx) => (
              <div
                key={idx}
                className="bg-white border-4 border-black rounded-xl p-8 text-center shadow-hard"
                data-testid={`feature-card-${idx}`}
              >
                <div className="bg-brand_yellow w-20 h-20 rounded-full border-4 border-black mx-auto mb-4 flex items-center justify-center">
                  <feature.icon className="w-10 h-10" strokeWidth={3} />
                </div>
                <h3 className="font-chewy text-2xl text-brand_blue mb-2">
                  {feature.title}
                </h3>
                <p className="font-nunito text-gray-700 font-semibold">
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-brand_blue border-t-4 border-black relative overflow-hidden">
        {/* Decorative Stars */}
        <div className="absolute top-10 right-20 w-8 h-8">
          <div className="w-full h-full bg-brand_yellow/80 animate-pulse" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)' }} />
        </div>
        <div className="absolute bottom-16 left-16 w-10 h-10">
          <div className="w-full h-full bg-white/60 rotate-12" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)' }} />
        </div>
        <div className="absolute top-1/3 left-1/4 w-6 h-6">
          <div className="w-full h-full bg-brand_red/70 animate-spin" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)', animationDuration: '10s' }} />
        </div>
        <div className="absolute bottom-1/4 right-1/3 w-7 h-7">
          <div className="w-full h-full bg-brand_green/60 rotate-45" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)' }} />
        </div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h2 className="font-chewy text-4xl sm:text-6xl text-white mb-6 drop-shadow-[2px_2px_0px_rgba(0,0,0,1)]">
            READY TO TASTE THE BEST?
          </h2>
          <p className="font-nunito text-xl text-white mb-8 font-semibold">
            Order now and experience Uncle Dave's legendary lemonade!
          </p>
          <Link
            to="/products"
            className="inline-block bg-brand_red text-white font-chewy text-2xl px-12 py-4 rounded-full border-4 border-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] hover:-translate-y-1 transition-all"
            data-testid="cta-shop-button"
          >
            START SHOPPING
          </Link>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="py-16 bg-white border-t-4 border-black">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-off_white border-4 border-black rounded-2xl p-8 shadow-hard">
            <img
              src="https://customer-assets.emergentagent.com/job_uncle-dave-lemonade/artifacts/6i672sfq_Copy%20of%20UNCLE_20251013_143543_0000.png"
              alt="Contact Uncle Dave's"
              className="w-full h-auto rounded-lg"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;